var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import useAccumulatorChangeUploadAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/ACCUMULATOR_CHANGE_UPLOAD_ATTACHMENT';
import useFertilityMaximumUploadAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/FERTILITY_MAXIMUM_UPLOAD_ATTACHMENT';
import useGroupNumberChangeUploadAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/GROUP_NUMBER_CHANGE_UPLOAD_ATTACHMENT';
import usePlanChangeHandlingUploadAttachment from 'apollo/mutations/PlanChangeHandlingAttachment/PLAN_CHANGE_HANDLING_UPLOAD_ATTACHMENT';
import useImpactReportUploadAttachment from 'apollo/mutations/ImpactReportAttachment/IMPACT_REPORT_UPLOAD_ATTACHMENT';
import useBenefitInquiryUploadAttachment from 'apollo/mutations/BenefitInquiryAttachment/BENEFIT_INQUIRY_UPLOAD_ATTACHMENT';
import useDrugListUpdateRequestUploadAttachment from 'apollo/mutations/DrugListUpdateAttachment/DRUG_LIST_UPDATE_UPLOAD_ATTACHMENT';
import useAccumulatorIssueUploadAttachment from 'apollo/mutations/AccumulatorIssueAttachment/ACCUMULATOR_ISSUE_UPLOAD_ATTACHMENT';
import useVendorSetupUploadAttachment from 'apollo/mutations/VendorSetupAttachment/VENDOR_SETUP_UPLOAD_ATTACHMENT';
import useNewImplementationUploadAttachment from 'apollo/mutations/NewImplementationAttachment/NEW_IMPLEMENTATION_UPLOAD_ATTACHMENT';
import useClaimFileProcessingUploadAttachment from 'apollo/mutations/ClaimFileProcessingAttachment/CLAIM_FILE_PROCESSING_UPLOAD_ATTACHMENT';
// Type guard for array attachments
var isAttachmentArray = function (att) {
    return Array.isArray(att);
};
var useTicketHandlingAttachments = function () {
    var onAccumulatorChangeUploadAttachment = useAccumulatorChangeUploadAttachment().onAccumulatorChangeUploadAttachment;
    var onFertilityMaximumUploadAttachment = useFertilityMaximumUploadAttachment().onFertilityMaximumUploadAttachment;
    var onGroupNumberChangeUploadAttachment = useGroupNumberChangeUploadAttachment().onGroupNumberChangeUploadAttachment;
    var onPlanChangeHandlingUploadAttachment = usePlanChangeHandlingUploadAttachment().onPlanChangeHandlingUploadAttachment;
    var onImpactReportUploadAttachment = useImpactReportUploadAttachment().onImpactReportUploadAttachment;
    var onBenefitInquiryAttachmentUpload = useBenefitInquiryUploadAttachment().onBenefitInquiryAttachmentUpload;
    var onDrugListUpdateRequestAttachmentUpload = useDrugListUpdateRequestUploadAttachment().onDrugListUpdateRequestAttachmentUpload;
    var onAccumulatorIssueAttachmentUpload = useAccumulatorIssueUploadAttachment().onAccumulatorIssueAttachmentUpload;
    var onVendorSetupAttachmentUpload = useVendorSetupUploadAttachment().onVendorSetupAttachmentUpload;
    var onNewImplementationAttachmentUpload = useNewImplementationUploadAttachment().onNewImplementationAttachmentUpload;
    var onClaimFileProcessingAttachmentUpload = useClaimFileProcessingUploadAttachment().onClaimFileProcessingAttachmentUpload;
    var uploadAttachments = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var isAccumulatorChange, isFertilityMaximum, isGroupNumberChange, isPlanChangeHandling, isImpactReport, isBenefitInquiry, isDrugListUpdate, isAccumulatorIssue, isVendorSetup, isNewImplementation, isClaimFileProcessing, nestedAttachments_1, attachmentTypes, flattenedAttachments, formattedAttachments;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var ticketType = _b.ticketType, sourceId = _b.sourceId, attachments = _b.attachments;
        return __generator(this, function (_q) {
            switch (_q.label) {
                case 0:
                    if (!attachments || !sourceId) {
                        return [2 /*return*/];
                    }
                    isAccumulatorChange = ticketType.isAccumulatorChange, isFertilityMaximum = ticketType.isFertilityMaximum, isGroupNumberChange = ticketType.isGroupNumberChange, isPlanChangeHandling = ticketType.isPlanChangeHandling, isImpactReport = ticketType.isImpactReport, isBenefitInquiry = ticketType.isBenefitInquiry, isDrugListUpdate = ticketType.isDrugListUpdate, isAccumulatorIssue = ticketType.isAccumulatorIssue, isVendorSetup = ticketType.isVendorSetup, isNewImplementation = ticketType.isNewImplementation, isClaimFileProcessing = ticketType.isClaimFileProcessing;
                    if (!(isNewImplementation && !isAttachmentArray(attachments))) return [3 /*break*/, 3];
                    nestedAttachments_1 = attachments;
                    attachmentTypes = [
                        'accumulator',
                        'claim',
                        'eligibility',
                        'id_cards'
                    ];
                    flattenedAttachments = attachmentTypes.flatMap(function (type) {
                        return (nestedAttachments_1[type] || []).map(function (item) {
                            var _a;
                            return ({
                                file: (_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.image,
                                title: "".concat(item === null || item === void 0 ? void 0 : item.title, "-").concat(type),
                                notes: item === null || item === void 0 ? void 0 : item.notes
                            });
                        });
                    });
                    if (!flattenedAttachments.length) return [3 /*break*/, 2];
                    return [4 /*yield*/, onNewImplementationAttachmentUpload({
                            source_id: sourceId,
                            attachments: flattenedAttachments
                        })];
                case 1:
                    _q.sent();
                    _q.label = 2;
                case 2: return [2 /*return*/];
                case 3:
                    // All other ticket types use array attachments
                    if (!isAttachmentArray(attachments)) {
                        return [2 /*return*/];
                    }
                    if (!(isBenefitInquiry && attachments.length)) return [3 /*break*/, 5];
                    return [4 /*yield*/, onBenefitInquiryAttachmentUpload({
                            id: sourceId,
                            attachment: {
                                file: (_d = (_c = attachments[0]) === null || _c === void 0 ? void 0 : _c.file) === null || _d === void 0 ? void 0 : _d.image,
                                title: (_e = attachments[0]) === null || _e === void 0 ? void 0 : _e.title,
                                notes: (_f = attachments[0]) === null || _f === void 0 ? void 0 : _f.notes
                            }
                        })];
                case 4:
                    _q.sent();
                    _q.label = 5;
                case 5:
                    if (!(isDrugListUpdate && attachments.length)) return [3 /*break*/, 7];
                    return [4 /*yield*/, onDrugListUpdateRequestAttachmentUpload({
                            id: sourceId,
                            attachment: {
                                file: (_h = (_g = attachments[0]) === null || _g === void 0 ? void 0 : _g.file) === null || _h === void 0 ? void 0 : _h.image,
                                title: (_j = attachments[0]) === null || _j === void 0 ? void 0 : _j.title,
                                notes: (_k = attachments[0]) === null || _k === void 0 ? void 0 : _k.notes
                            }
                        })];
                case 6:
                    _q.sent();
                    _q.label = 7;
                case 7:
                    if (!(isAccumulatorIssue && attachments.length)) return [3 /*break*/, 9];
                    return [4 /*yield*/, onAccumulatorIssueAttachmentUpload({
                            id: sourceId,
                            attachment: {
                                file: (_m = (_l = attachments[0]) === null || _l === void 0 ? void 0 : _l.file) === null || _m === void 0 ? void 0 : _m.image,
                                title: (_o = attachments[0]) === null || _o === void 0 ? void 0 : _o.title,
                                notes: (_p = attachments[0]) === null || _p === void 0 ? void 0 : _p.notes
                            }
                        })];
                case 8:
                    _q.sent();
                    _q.label = 9;
                case 9:
                    formattedAttachments = attachments.map(function (item) {
                        var _a;
                        return ({
                            file: (_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.image,
                            title: item === null || item === void 0 ? void 0 : item.title,
                            notes: item === null || item === void 0 ? void 0 : item.notes
                        });
                    });
                    if (!(isVendorSetup && attachments.length)) return [3 /*break*/, 11];
                    return [4 /*yield*/, onVendorSetupAttachmentUpload({
                            source_id: sourceId,
                            attachments: formattedAttachments
                        })];
                case 10:
                    _q.sent();
                    _q.label = 11;
                case 11:
                    if (!(isClaimFileProcessing && attachments.length)) return [3 /*break*/, 13];
                    return [4 /*yield*/, onClaimFileProcessingAttachmentUpload({
                            source_id: sourceId,
                            attachments: formattedAttachments
                        })];
                case 12:
                    _q.sent();
                    _q.label = 13;
                case 13:
                    if (!(isAccumulatorChange && attachments.length)) return [3 /*break*/, 15];
                    return [4 /*yield*/, onAccumulatorChangeUploadAttachment({
                            source_id: sourceId,
                            attachments: formattedAttachments
                        })];
                case 14:
                    _q.sent();
                    _q.label = 15;
                case 15:
                    if (!(isFertilityMaximum && attachments.length)) return [3 /*break*/, 17];
                    return [4 /*yield*/, onFertilityMaximumUploadAttachment({
                            source_id: sourceId,
                            attachments: formattedAttachments
                        })];
                case 16:
                    _q.sent();
                    _q.label = 17;
                case 17:
                    if (!(isGroupNumberChange && attachments.length)) return [3 /*break*/, 19];
                    return [4 /*yield*/, onGroupNumberChangeUploadAttachment({
                            source_id: sourceId,
                            attachments: formattedAttachments
                        })];
                case 18:
                    _q.sent();
                    _q.label = 19;
                case 19:
                    if (!(isPlanChangeHandling && attachments.length)) return [3 /*break*/, 21];
                    return [4 /*yield*/, onPlanChangeHandlingUploadAttachment({
                            source_id: sourceId,
                            attachments: formattedAttachments
                        })];
                case 20:
                    _q.sent();
                    _q.label = 21;
                case 21:
                    if (!(isImpactReport && attachments.length)) return [3 /*break*/, 23];
                    return [4 /*yield*/, onImpactReportUploadAttachment({
                            source_id: sourceId,
                            attachments: formattedAttachments
                        })];
                case 22:
                    _q.sent();
                    _q.label = 23;
                case 23: return [2 /*return*/];
            }
        });
    }); };
    return { uploadAttachments: uploadAttachments };
};
export default useTicketHandlingAttachments;
